import React from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { Grid, HelpCircle, Info, LogIn, LogOut, UserPlus } from 'react-feather';

/**
 * Public app shell with top navigation and nested route outlet.
 * Hides main nav on dashboard/profile routes (they have their own sidebar nav).
 * @param {{ session: any, onLogout: () => void }} props
 */
function MainLayout({ session, onLogout }) {
  const location = useLocation();
  const getActiveClass = ({ isActive }) => (isActive ? 'nav-item active' : 'nav-item');
  const primaryAction = session
    ? { to: '/dashboard', icon: <Grid aria-hidden="true" />, label: 'Dashboard' }
    : { to: '/login', icon: <LogIn aria-hidden="true" />, label: 'Login' };

  // Routes that have their own navigation (dashboard sidebar)
  const isDashboardRoute = location.pathname.startsWith('/dashboard');

  // Routes that should take up the full width (no container constraint)
  const isFullWidthRoute = ['/login', '/signup'].includes(location.pathname);

  return (
    <>
      {!isDashboardRoute && (
        <div className="main-nav-container">
          <nav className="main-nav" aria-label="Main Navigation">
            <NavLink to="/" className="logo-link nav-item" aria-label="Home">
              <div className="logo">Task Square (Beta)</div>
            </NavLink>
            <NavLink to="/how-it-works" className={getActiveClass}>
              <HelpCircle className="nav-icon" aria-hidden="true" />
              <span className="nav-label">How it Works</span>
            </NavLink>

            <NavLink to={primaryAction.to} className="nav-primary-action" aria-label={primaryAction.label}>
              {primaryAction.icon}
            </NavLink>

            <NavLink to="/about" className={getActiveClass}>
              <Info className="nav-icon" aria-hidden="true" />
              <span className="nav-label">About</span>
            </NavLink>
            {session ? (
              <button type="button" onClick={(e) => { e.preventDefault(); console.log('Logout clicked'); onLogout(); }} className="nav-item action-btn">
                <LogOut className="nav-icon" aria-hidden="true" />
                <span className="nav-label">Sign Out</span>
              </button>
            ) : (
              <NavLink to="/signup" className={getActiveClass}>
                <UserPlus className="nav-icon" aria-hidden="true" />
                <span className="nav-label">Sign Up</span>
              </NavLink>
            )}
          </nav>
        </div>
      )}
      <div className={(isDashboardRoute || isFullWidthRoute) ? '' : 'container-1200'}>
        <Outlet />
      </div>
    </>
  );
}

export default MainLayout;

